export const drawTechnicianLabel = (technician) => {
    return `${technician.firstName} ${technician.lastName} ${technician.phone ? `- ${technician.phone}` : ""}`;
};
export const drawServiceVehicleLabel = (serviceVehicle) => {
    return `${serviceVehicle.brand} ${serviceVehicle.model} (${serviceVehicle.licensePlate})`;
};
export const drawChargingStationLabel = (chargingStation) => {
    return `${chargingStation.serialNumber}`;
};
